module.exports = __webpack_public_path__ + "img/not-goods.png?v=a9e4c3b3";